import React from 'react'
import RootAuthPages from './RootAuthPages'

export * from './RootAuthPages'
export default React.memo(RootAuthPages)
